<!-- <button mat-icon-button class="close-button" [mat-dialog-close]="true" (click)="dialogRef.close(false)">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button> -->

<h1 mat-dialog-title class="text-center blueHeader dialogHeader text-white">Confirm</h1>
<mat-dialog-content class="mb-4 text-center">{{confirmMessage}}</mat-dialog-content>
<mat-dialog-actions>
  <div class="row col-md-12 ml-3">
    <button mat-button class="mat-raised-button mr-4 btn blankTurquoise btnWidth"
    (click)="dialogRef.close(false)">{{cancelButton}}</button>
    <button mat-button class="mat-raised-button btn turquoiseBtn btnWidth" (click)="dialogRef.close(true)">{{successButton}}</button>
  </div>
</mat-dialog-actions>
